import React from 'react'
import { handleErrorCode } from './error-helper'
import { ErrorWrapper } from './ErrorMsgStyledComponent'

interface ErrorMsgProps {
  errorCode?: string
}

const ErrorMsg: React.FC<ErrorMsgProps> = ({
  errorCode
}) => {
  return (
    <>
      <ErrorWrapper id="error-message">{handleErrorCode(errorCode)}</ErrorWrapper>
    </>
  )
}

export default ErrorMsg